module.exports = __webpack_public_path__ + "img/auxiliar-de-manutencao.955bab39.png";